import { CoreVideoSdk, loadSdk, VacType, OverrideableDevice, Proposition } from "@sky-uk-ott/core-video-sdk-js";
import { loadDeviceFactory } from "@sky-uk-ott/client-lib-js-device";
import { useState, useEffect } from "react";
import { getConvivaConfig, MEDIA_TAILOR_URLS, VAM_URLS } from "./configs.js";
import { useVpiProvider } from "./useVpiProvider.js";
let coreVideoSdkPromise;
const loadDevice = async (deviceConfig) => {
  const deviceFactory = await loadDeviceFactory(deviceConfig);
  const device = await deviceFactory.initialise();
  return device;
};
function useCoreVideoSdk(sdkConfigParams, signRequest, streamConfig) {
  const [isCvsdkLoaded, setIsCvsdkLoaded] = useState(CoreVideoSdk.isInitialised);
  const { sessionKey, vpiProvider } = useVpiProvider({ signRequest, streamConfig });
  useEffect(
    () => {
      if (!isCvsdkLoaded) {
        const deviceConfig = {};
        coreVideoSdkPromise ?? (coreVideoSdkPromise = loadDevice(deviceConfig).then((device) => loadSdk(getSdkConfig(sdkConfigParams), device, vpiProvider)).catch((reason) => {
          console.error("[CVSDK] Initialization failure:", reason);
          return Promise.reject(reason);
        }));
        let ignore = false;
        coreVideoSdkPromise.then(() => {
          if (!ignore) {
            setIsCvsdkLoaded(true);
          }
        });
        return () => {
          ignore = true;
        };
      }
      return void 0;
    }
    // Note: we call this on every render
  );
  return {
    sessionKey,
    cvsdk: isCvsdkLoaded ? CoreVideoSdk : void 0
  };
}
function getSdkConfig({
  appVersion,
  appName,
  appBrand,
  appIdentifier,
  deviceAdvertisingId,
  mtEndpoint = "prod",
  vamEndpoint = "prod",
  convivaEnvironment
}) {
  const result = {
    proposition: Proposition.OneApp,
    vpi: { useCustomVpip: true },
    deviceOverride: OverrideableDevice.Browser,
    addons: {
      common: { appVersion, appName, appIdentifier },
      adInsertion: {
        enabled: true,
        mediaTailorAdInsertionOverrideLinear: true,
        mediaTailorAdInsertionOverrideFer: true,
        vac: {
          type: VacType.VAM,
          url: VAM_URLS[vamEndpoint],
          requestData: {
            appName,
            appBrand,
            appBundleId: "com.nbcnews.tvx",
            appBuild: appVersion,
            deviceAdvertisingId,
            deviceAdvertisingIdType: ""
          }
        },
        mediaTailor: {
          host: MEDIA_TAILOR_URLS[mtEndpoint],
          mtUrl: MEDIA_TAILOR_URLS[mtEndpoint],
          debug: true
        }
      },
      reporting: {
        openMeasurement: {
          config: {
            partnerName: "nbcuni",
            isDebug: false
          },
          enabled: true
        },
        conviva: getConvivaConfig(convivaEnvironment ?? "none", appName)
      }
    }
  };
  return result;
}
export {
  useCoreVideoSdk
};
//# sourceMappingURL=useCoreVideoSdk.js.map
